import React from 'react';
import MuiTextField, {TextFieldProps} from '@material-ui/core/TextField';
import {FieldValues, useController} from 'react-hook-form';
import {makeStyles} from '@material-ui/core';
import {UseControllerProps} from './types';
import {getDirectionStyles} from '../../../utils/ThemeUtils';

const useStyles = makeStyles(theme => ({
    textFieldRoot: {
        margin: theme.spacing(2, 0)
    },
    inputOutlined: {
        left: getDirectionStyles(theme.direction)(0, 'unset'),
        marginRight: getDirectionStyles(theme.direction)('unset', 0),
        transform: getDirectionStyles(theme.direction)(
            'translate(20px, 20px) scale(1)',
            'translate(-20px, 20px) scale(1)'
        )
    },
    inputFilled: {
        left: getDirectionStyles(theme.direction)(0, 'unset'),
        right: getDirectionStyles(theme.direction)('unset', 0),
        transform: getDirectionStyles(theme.direction)(
            'translate(20px, 20px) scale(1)',
            'translate(-20px, 20px) scale(1)'
        )
    },
    inputShrink: {
        transform: `${getDirectionStyles(theme.direction)(
            'translate(20px, 10px) scale(0.875)',
            'translate(-10px, 10px) scale(0.875)'
        )} !important;`
    },
    helperTextRoot: {
        textAlign: getDirectionStyles(theme.direction)('left', 'right')
    }
}));

export type InputProps<FormValues extends FieldValues> = UseControllerProps<
    TextFieldProps,
    FormValues
>;

function Input<FormValues>({
    name,
    rules,
    control,
    defaultValue = '',
    shouldUnregister = true,
    // textFieldProps
    variant,
    classes,
    InputLabelProps,
    FormHelperTextProps,
    ...textFieldProps
}: React.PropsWithChildren<InputProps<FormValues>>) {
    const styles = useStyles();
    const controller = useController({control, name, rules, defaultValue, shouldUnregister});
    const {field, fieldState} = controller;
    const {invalid, error} = fieldState;
    return (
        <MuiTextField
            {...textFieldProps}
            {...field}
            classes={{root: styles.textFieldRoot, ...classes}}
            variant={variant}
            error={invalid}
            helperText={error && error.message}
            InputLabelProps={{
                ...InputLabelProps,
                classes: {
                    outlined: styles.inputOutlined,
                    filled: styles.inputFilled,
                    shrink: styles.inputShrink
                }
            }}
            FormHelperTextProps={{
                ...FormHelperTextProps,
                classes: {
                    root: styles.helperTextRoot
                }
            }}
        />
    );
}

export default Input;
